<template>
  <div
    v-if="!props.payload?.content || props.payload?.content.length === 0"
    :class="`ao__${props.type}`"
    v-html="props.payload?.rendered"
  />
  <div
    v-else-if="props.payload?.content && props.payload?.content.length > 0"
    :class="`ao__${props.type}`"
  >
    <DefaultArticlesArtObject
      v-for="(content, index) in props.payload?.content"
      :type="content?.type"
      :payload="content"
      :parent-ident="`${props.parentIdent}|${props.type}-${index}`"
    />
  </div>
  <div v-else />
</template>


<script setup lang="ts">
const props = defineProps({
  type: { type: String, required: true },
  payload: { type: Object, required: false },
  parentIdent: { type: String, required: false },
})
</script>

<style lang="postcss" scoped>
</style>
